import { Api } from '../../axios-config/AxiosConfig';
import { ApiException } from '../ApiException';
import { Environment } from '../../../environment';

export interface Equipes {
  id?: string | number;
  nome: string;
}

const createEquipe = async (
  dados: Equipes
): Promise<string | number> => {
  try {
    const { data } = await Api.post(
      `${Environment.API_GATEWAY}/arquiteturac4model/api/v1/Equipes`,
      dados,
      {
        headers: {
          idTenant: 'gvdasa-cloud',
        },
      }
    );
    return data as string | number;
  } catch (error: any) {
    throw new ApiException(error.data.data.errors.erro || 'Erro ao salvar equipe');
  }
};

const getAllEquipes = async (
  page: string,
  limite = 25,
  offset = 0,
  NomeParte?: string,
  order?: string,
  sortBy?: string
): Promise<{ data: Equipes[]; totalCount: number }> => {
  try {
    // Construindo a query string com os parâmetros
    let queryParams = `?page=${page}&limite=${limite}&offset=${offset}`;

    // Adiciona filtro se existir
    if (NomeParte && NomeParte.trim()) {
      queryParams += `&NomeParte=${encodeURIComponent(NomeParte)}`;
    }

    // Adiciona ordenação se existir
    if (sortBy && order) {
      queryParams += `&sortBy=${sortBy}&order=${order}`;
    }

    const { data, headers } = await Api.get(
      `${Environment.API_GATEWAY}/arquiteturac4model/api/v1/Equipes${queryParams}`,
      {
        headers: {
          idTenant: 'gvdasa-cloud',
        },
      }
    );

    return {
      data: data as Equipes[],
      totalCount: Number(headers['x-total-count']),
    };

  } catch (error: any) {
    console.error('Erro ao consultar equipes:', error);
    throw new ApiException(
      error.data.data.erro || 'Erro ao consultar equipes.'
    );
  }
};

const getEquipesById = async (
  id: string | number
): Promise<Equipes> => {
  try {
    const { data } = await Api.get(
      `${Environment.API_GATEWAY}/arquiteturac4model/api/v1/Equipes/${id}`,
      {
        headers: {
          idTenant: 'gvdasa-cloud',
        },
      }
    );
    return data as Equipes;
  } catch (error: any) {
    console.error(error);
    throw new ApiException(error.data.data.erro || 'Erro ao buscar os dados da equipe');
  }
};

const deleteEquipeById = async (
  id: string | number
): Promise<void> => {
  try {
    await Api.delete(
      `${Environment.API_GATEWAY}/arquiteturac4model/api/v1/Equipes/${id}`,
      {
        headers: {
          idTenant: 'gvdasa-cloud',
        },
      }
    );
    return;
  } catch (error: any) {
    console.error(error);
    throw new ApiException(error.data.data.erro || 'Erro ao excluir a equipe');
  }
};

const updateEquipeById = async (
  id: string | number,
  dados: Equipes
): Promise<void> => {
  try {
    await Api.put(
      `${Environment.API_GATEWAY}/arquiteturac4model/api/v1/Equipes/${id}`,
      dados,
      {
        headers: {
          idTenant: 'gvdasa-cloud',
        },
      }
    );
    return;
  } catch (error: any) {
    throw new ApiException(error.data.data.erro || 'Erro ao salvar equipe');
  }
};

export const C4ModelEquipesService = {
  getAllEquipes,
  getEquipesById,
  deleteEquipeById,
  updateEquipeById,
  createEquipe,
};
